import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import TataLaksanaKerja from './TataLaksanaKerja';
import PrinsipHubunganKerja from './PrinsipHubunganKerja';

function BoardManualLayout() {
    const items = [
        { id: 'tata-laksana-kerja', number: '01', label: 'Tata Laksana Kerja', content: <TataLaksanaKerja /> },
        { id: 'prinsip-hubungan-kerja', number: '02', label: 'Prinsip Hubungan Kerja', content: <PrinsipHubunganKerja /> },
    ];
    return <>
        <Helmet><title>Board Manual | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Board Manual PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/board-manual" /></Helmet>
        <PageHeader title="Board Manual" />
        <CorporateSectionLayout title="Board Manual" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default BoardManualLayout;
